/** «Очередь лидов» — ровно то, что отдаёт `GET /api/leads/queue`. */
import { apiFetch, query } from "@/lib/api";
import type { Count } from "@/lib/leads";

export type QueueHour = {
  label: string;
  start: string;
  end: string;
  current: boolean;
  queue_start: number;
  queue_end: number;
  in_new: number;
  in_back: number;
  out_work: number;
  out_closed: number;
  out_calls: number;
  out_talk: number;
  in_calls: number;
  in_talk: number;
};

export type QueueLead = {
  lead_id: number;
  created: string;
  source: string;
  phone: string;
  since: string;
  returned: boolean;
  out: number;
  last_out: string | null;
};

export type LeadQueue = {
  day: string;
  now: string;
  is_today: boolean;
  queue_now: {
    total: number;
    /** NEW без российского номера — обзвонить нельзя, в очередь не входят. */
    no_phone: number;
    by_age: { today: number; yesterday: number; older: number };
    by_source: Count[];
    leads: QueueLead[];
  };
  hours: QueueHour[];
  totals: Omit<QueueHour, "label" | "start" | "end" | "current" | "queue_start" | "queue_end"> & { out_leads: number };
};

/** Карточка лида в Битриксе — так же ссылается legacy CRM. */
export const leadUrl = (id: number) => `https://unirenter.bitrix24.ru/crm/lead/details/${id}/`;

export function loadLeadQueue(day: string): Promise<LeadQueue> {
  return apiFetch<LeadQueue>(`/api/leads/queue${query({ date: day })}`);
}
